import React, { Component } from "react";
import Proiect from "./Proiect";
import Footer from "./Footer";

const TITLU = "Proiect cofinanțat de Uniunea Europeană — KFY Auto";
const DESCRIERE =
  "„Excelenta in servicii auto prin investitii in tehnologie performanta la SC KFY CAR PARTS SRL”, cod SMIS 328644, cofinanțat prin Programul Regional Sud-Vest Oltenia 2021-2027.";
const URL = "https://www.kfyauto.ro/proiect-regio/";

// Pagina separata /proiect-regio (deschisa din cele doua bannere de sus).
// Titlul/canonical/descrierea se seteaza aici; react-snap le salveaza in HTML-ul paginii.
class ProiectPage extends Component {
  componentDidMount() {
    document.title = TITLU;
    const set = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    set('link[rel="canonical"]', "href", URL);
    set('meta[name="description"]', "content", DESCRIERE);
    set('meta[property="og:url"]', "content", URL);
    set('meta[property="og:title"]', "content", TITLU);
    set('meta[property="og:description"]', "content", DESCRIERE);
  }

  render() {
    return (
      <div id="top" className="proiect-page">
        <nav className="proiect-page-bar">
          <a href="/" className="proiect-page-home">
            <picture>
              <source srcSet="/images/logo_wb.webp" type="image/webp" />
              <img src="/images/logo_wb.png" alt="KFY Auto" height="40" />
            </picture>
          </a>
          <a href="/" className="proiect-page-back">← Înapoi la pagina principală</a>
        </nav>

        <Proiect />
        <Footer data={this.props.data} />
      </div>
    );
  }
}

export default ProiectPage;
